import Region from "../Region";
import RegionArea from "../RegionArea";
import Phaser from 'phaser';

import * as ABCya from '@abcya/abcya_phaser';
import UIAssetKeys from '../UIAssetKeys';
import { AREAS, SHAPES } from '../gameData';

export default class DomeArea extends RegionArea
{
    /**
     * @param {Region} region the owner region
     */
    constructor(parentRegion)
    {
        super(parentRegion, AREAS[parentRegion.region].DOME);

        this._createArea();

        this.reset();
    }

    /**
     * Reset should be called when you want to set the state to a disabled/inactive state.
     */
    reset()
    {
        super.reset();

        this.doorSide.setAlpha(0);
        this.doorTop.setAlpha(0);
        this.pentagonSide.setAlpha(0);
        this.pentagonTop.setAlpha(0);
        this.hexagon1.setAlpha(0);
        this.hexagon2.setAlpha(0);
        this.hexagon3.setAlpha(0);
    }

    /**
     * Prepare should be called before you want to prepare the state to become active.
     */
    prepare()
    {
        super.prepare();

        this.doorSide.disableInteractive();
        this.doorTop.disableInteractive();
        this.pentagonSide.disableInteractive();
        this.pentagonTop.disableInteractive();
        this.hexagon1.disableInteractive();
        this.hexagon2.disableInteractive();
        this.hexagon3.disableInteractive();
    }

    /**
     * Send all game objects to their start positions.
     */
    _sendObjectsToStartPositions()
    {
        super._sendObjectsToStartPositions();

        this.doorSide.setAlpha(0.000001);
        this.doorTop.setAlpha(0.000001);
        this.pentagonSide.setAlpha(0.000001);
        this.pentagonTop.setAlpha(0.000001);
        this.hexagon1.setAlpha(0.000001);
        this.hexagon2.setAlpha(0.000001);
        this.hexagon3.setAlpha(0.000001);
    }

    /**
     * Creates the area, by adding the overlays to the parent region and creates the area information sidebar.
     */
    _createArea()
    {
        let doorSideHitArea = new Phaser.Geom.Polygon(
            [
                { x: 10, y: 190 },
                { x: 0, y: 21 },
                { x: 36, y: 0 },
                { x: 43, y: 171 },
            ]);
        this.doorSide = ABCya.Images.addImage(662, 524, UIAssetKeys._12_Space_Zoom_In_Dome_Slct_Rctngl_Sd, this.parentRegion).setInteractive(doorSideHitArea, Phaser.Geom.Polygon.Contains);
        this.doorSide.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () =>
        {
            this._onOverlayPointerDown(this.doorSide, SHAPES.RECTANGLE);
        });

        let doorTopHitArea = new Phaser.Geom.Polygon(
            [
                { x: 156, y: 71 },
                { x: 0, y: 21 },
                { x: 34, y: 0 },
                { x: 190, y: 49 },
            ]);
        this.doorTop = ABCya.Images.addImage(583, 419, UIAssetKeys._12_Space_Zoom_In_Dome_Slct_Rctngl_Top, this.parentRegion).setInteractive(doorTopHitArea, Phaser.Geom.Polygon.Contains);
        this.doorTop.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () =>
        {
            this._onOverlayPointerDown(this.doorTop, SHAPES.RECTANGLE);
        });

        let pentagonSideHitArea = new Phaser.Geom.Polygon(
            [
                { x: 58, y: 177 },
                { x: 0, y: 95 },
                { x: 43, y: 0 },
                { x: 127, y: 22 },
                { x: 137, y: 133 },
            ]);
        this.pentagonSide = ABCya.Images.addImage(844, 417, UIAssetKeys._12_Space_Zoom_In_Dome_Slct_Penta2, this.parentRegion).setInteractive(pentagonSideHitArea, Phaser.Geom.Polygon.Contains);
        this.pentagonSide.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () =>
        {
            this._onOverlayPointerDown(this.pentagonSide, SHAPES.PENTAGON);
        });

        let pentagonTopHitArea = new Phaser.Geom.Polygon(
            [
                { x: 48, y: 103 },
                { x: 0, y: 46 },
                { x: 78, y: 0 },
                { x: 175, y: 29 },
                { x: 157, y: 93 },
            ]);
        this.pentagonTop = ABCya.Images.addImage(689, 210, UIAssetKeys._12_Space_Zoom_In_Dome_Slct_Penta1, this.parentRegion).setInteractive(pentagonTopHitArea, Phaser.Geom.Polygon.Contains);
        this.pentagonTop.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () =>
        {
            this._onOverlayPointerDown(this.pentagonTop, SHAPES.PENTAGON);
        });

        let hexagon1HitArea = new Phaser.Geom.Polygon(
            [
                { x: 51, y: 190 },
                { x: 0, y: 134 },
                { x: 43, y: 38 },
                { x: 136, y: 0 },
                { x: 184, y: 56 },
                { x: 143, y: 152 },
            ]);
        this.hexagon1 = ABCya.Images.addImage(563, 296, UIAssetKeys._12_Space_Zoom_In_Dome_Slct_Hex1, this.parentRegion).setInteractive(hexagon1HitArea, Phaser.Geom.Polygon.Contains);
        this.hexagon1.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () =>
        {
            this._onOverlayPointerDown(this.hexagon1, SHAPES.HEXAGON);
        });

        let hexagon2HitArea = new Phaser.Geom.Polygon(
            [
                { x: 66, y: 191 },
                { x: 0, y: 105 },
                { x: 41, y: 10 },
                { x: 151, y: 0 },
                { x: 217, y: 86 },
                { x: 174, y: 180 },
            ]);
        this.hexagon2 = ABCya.Images.addImage(714, 340, UIAssetKeys._12_Space_Zoom_In_Dome_Slct_Hex2, this.parentRegion).setInteractive(hexagon2HitArea, Phaser.Geom.Polygon.Contains);
        this.hexagon2.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () =>
        {
            this._onOverlayPointerDown(this.hexagon2, SHAPES.HEXAGON);
        });

        let hexagon3HitArea = new Phaser.Geom.Polygon(
            [
                { x: 148, y: 171 },
                { x: 66, y: 149 },
                { x: 0, y: 64 },
                { x: 18, y: 0 },
                { x: 100, y: 22 },
                { x: 167, y: 107 },
            ]);
        this.hexagon3 = ABCya.Images.addImage(837, 270, UIAssetKeys._12_Space_Zoom_In_Dome_Slct_Hex3, this.parentRegion).setInteractive(hexagon3HitArea, Phaser.Geom.Polygon.Contains);
        this.hexagon3.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () =>
        {
            this._onOverlayPointerDown(this.hexagon3, SHAPES.HEXAGON);
        });

        this.shapeOverlays[SHAPES.RECTANGLE] = [this.doorSide, this.doorTop];
        this.shapeOverlays[SHAPES.HEXAGON] = [this.hexagon1, this.hexagon2, this.hexagon3];
        this.shapeOverlays[SHAPES.PENTAGON] = [this.pentagonSide, this.pentagonTop];

        this._createAreaInformation(0x5f5fd6, 0x67adb9);
    }

    /**
     * Zoom into the area.
     */
    zoomIn()
    {
        let tweens = super.zoomIn();

        tweens.push(
            {
                targets: [
                    this.parentRegion.greenhouse, this.parentRegion.roverContainer
                ],
                duration: 500,
                props: { alpha: 0 },
                ease: Phaser.Math.Easing.Quadratic.Out,
            },
            { targets: this.parentRegion.dome, duration: 1000, props: { scale: 1, x: 694, y: 386 }, ease: Phaser.Math.Easing.Quadratic.Out, offset: 0 },
            { targets: this.areaInformation, duration: 500, props: { x: this.areaInformation.onScreenPosition.x }, ease: Phaser.Math.Easing.Back.Out, offset: 500 }
        );

        return tweens;
    }

    /**
     * Zoom out of the area.
     */
    zoomOut()
    {
        let tweens = super.zoomOut();

        this.doorSide.disableInteractive();
        this.doorTop.disableInteractive();
        this.pentagonSide.disableInteractive();
        this.pentagonTop.disableInteractive();
        this.hexagon1.disableInteractive();
        this.hexagon2.disableInteractive();
        this.hexagon3.disableInteractive();

        for (let shape in this.shapeOverlays)
        {
            // fade off the overlay
            tweens.push(
                {
                    targets: this.shapeOverlays[shape],
                    duration: 500,
                    props: { alpha: 0 },
                    ease: Phaser.Math.Easing.Quadratic.Out,
                    offset: 0
                }
            );
        }

        tweens.push(
            { targets: this.areaInformation, duration: 500, props: { x: this.areaInformation.offScreenPosition.x }, ease: Phaser.Math.Easing.Back.In, offset: 0 },
            { targets: this.parentRegion.dome, duration: 1000, props: { scale: .5697, x: this.parentRegion.dome.onScreenPosition.x, y: this.parentRegion.dome.onScreenPosition.y }, ease: Phaser.Math.Easing.Quadratic.Out, offset: 250 },
            { targets: [this.parentRegion.greenhouse, this.parentRegion.roverContainer], duration: 500, props: { alpha: 1 }, ease: Phaser.Math.Easing.Quadratic.Out, offset: 500 },
        );

        return tweens;
    }
}